<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="showDe" key="de">
        <div class="intro-img">
          <img src="images/jodler_de.svg" />
        </div>
        <div class="intro-text">Zum Starten Bildschirm berühren</div>
      </div>
      <div v-else key="en">
        <div class="intro-img">
          <img src="images/jodler_en.svg" />
        </div>
        <div class="intro-text">Touch to start</div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.intro-img {
  width: 75%;
  max-width: 920px;
  height: 570px;
  margin-top: 200px;
  margin-left: auto;
  margin-right: auto;
}

.intro-img img {
  width: 100%;
}

.intro-text {
  width: 50%;
  font-size: 35px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
export default {
  name: "Start",

  data() {
    return {
      showDe: true
    };
  },

  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    async start() {
      this.$router.push({
        name: "welcome"
      });
    },

    async mouseDownEventListener() {
      await this.start();
    },

    toggleLanguage() {
      this.showDe = !this.showDe;
      setTimeout(this.toggleLanguage, 5000);
    }
  },

  mounted() {
    if (global.wpfBridge && typeof global.wpfBridge.startEnter == "function") {
      global.wpfBridge.startEnter();
    }

    document
      .getElementsByTagName("body")[0]
      .addEventListener("mousedown", this.mouseDownEventListener);
    document.querySelector("body").style.color = "#ffffff";
    document.querySelector("body").style.backgroundColor = "#00692f";

    setTimeout(this.toggleLanguage, 5000);
  },

  beforeDestroy() {
    document
      .getElementsByTagName("body")[0]
      .removeEventListener("mousedown", this.mouseDownEventListener);
  }
};
</script>

